module.exports = __webpack_public_path__ + "static/about-developer2-bb548e2b096079ba8ecf911560ded919.jpg";